import React from 'react';

import { useEffect } from 'react';
import { initGA4 } from './helpers/gtag'; // adjust path if needed
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-tippy/dist/tippy.css';
import '@reach/tabs/styles.css';
import '@material/react-linear-progress/dist/linear-progress.css';

import { NodeManager } from 'src/lib/react-register-nodes';
import GlobalStyles from './globalStyles';
import RootRoutes from './RootRoutes';
import { AdminActionsBar } from './features/common';

const App = () => {
  useEffect(() => {
    initGA4();
  }, []);

  return (
    <>
      <GlobalStyles />
      <ToastContainer hideProgressBar />
      <NodeManager>
        <RootRoutes />
      </NodeManager>
      <AdminActionsBar />
    </>
  );
};

export default App;
